import { whenReady } from '../utils/product-swatches-registry';

export default class SmallSwatch extends HTMLElement {
  static get observedAttributes(): string[] {
    return ['data-color-handle'];
  }

  private swatch: HTMLElement | null = null;

  connectedCallback(): void {
    this.swatch = this.querySelector('[data-small-swatch-ref="swatch"]');
    if (!this.swatch) return;
    this.applyColor();
  }

  attributeChangedCallback(name: string): void {
    if (name !== 'data-color-handle') return;
    this.swatch = this.querySelector('[data-small-swatch-ref="swatch"]');
    if (!this.swatch) return;
    this.applyColor();
  }

  private async applyColor(): Promise<void> {
    const handle = this.dataset.colorHandle;

    if (!handle || !this.swatch) return;

    const { colors } = await whenReady();
    const color = colors[handle];
    if (!color) return;

    this.swatch.style.backgroundColor = color.hex;
    this.swatch.setAttribute('aria-label', color.label);
  }
}

customElements.define('small-swatch', SmallSwatch);
